import React from 'react';
import moment from 'moment';

const AnnotationCard = React.memo(({ annotation }) => {
  const isTask = annotation.tarea === 'Pendiente' || annotation.tarea === 'Completada';

  // Get user name and lastname initial
  const getUserDisplayName = () => {
    const userName = annotation.user_name || annotation.creator_name || '';
    const userLastname = annotation.user_lastname || '';
    const lastnameInitial = userLastname ? userLastname.charAt(0).toUpperCase() + '.' : '';
    return `${userName} ${lastnameInitial}`.trim() || 'Usuario';
  };

  return (
    <div className='py-4'>
      <div className='flex items-start justify-between mb-2'>
        <div className='flex-1'>
          {isTask && (
            <div className='mb-2'>
              <span
                className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${
                  annotation.tarea === 'Completada' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                }`}
              >
                {annotation.tarea === 'Completada' ? '✓ Tarea Completada' : '⏳ Tarea Pendiente'}
              </span>
            </div>
          )}
          <p className='text-base text-gray-900 leading-relaxed'>{annotation.anotacion}</p>
        </div>
      </div>
      <div className='flex items-center gap-4 mt-3 text-sm text-gray-500'>
        <div className='flex items-center gap-1 text-xs'>
          <span>👤</span>
          <span className='font-medium'>{getUserDisplayName()}</span>
        </div>
        <div className='flex items-center gap-1 text-xs'>
          <span>📅</span>
          <span>{moment(annotation.fecha).format('DD/MM/YYYY HH:mm')}</span>
        </div>
        {annotation.creator_role && (
          <div className='flex items-center gap-1 text-xs'>
            <span>🔑</span>
            <span className='capitalize'>{annotation.creator_role}</span>
          </div>
        )}
      </div>
    </div>
  );
});

export default AnnotationCard;
